module.exports = __webpack_public_path__ + "img/bank-title-th.6b11b5c2.png";